module.exports = __webpack_public_path__ + "img/7.536c4ee1.png";